import React from 'react';
import Template from '../../components/expertise/template'

const Wills = ()=> {
    return <Template expertise="wills" id={3} />
}
export default Wills